'use strict';

let tabSearch = new Tabs;
tabSearch.add('.search-butt');

let tabMenus = new Tabs;
tabMenus.add('.menu-tab');
